import axios from 'axios'
import { useMutation } from 'react-query'

const postExportRoutes = async ({
  orgUuid,
  appUuid,
  payload
}: {
  orgUuid: string
  appUuid: string
  payload: Record<any, any>
}) =>
  axios.post(
    `/Contrast/api/ng/${orgUuid}/applications/${appUuid}/route/bulk/export/filters/csv/async`,
    payload
  )

export const useMutateExportRoutes = (options) =>
  useMutation({ mutationFn: postExportRoutes, ...options })
